import React, { Component } from 'react';
import { connect } from 'app/lib/synaptik';
import { last } from 'lodash';
import { Box, Text, Button, Flex } from '@goodrx/matisse';
import moment from 'moment';
import Message from 'app/components/widgets/chat/message';

const DateHeader = ({ date }: any) => {
  const groupDate = moment(date);
  const isThisYear = groupDate.year() === moment().year();
  let dateString = groupDate.format('MMMM Do, YYYY');

  if (isThisYear) {
    dateString = moment(groupDate).calendar(undefined, {
      lastDay: '[Yesterday]',
      sameDay: '[Today]',
      lastWeek: 'MMMM Do',
      sameElse: 'MMMM Do',
    });
  }
  return (
    <Flex alignItems="center" my={3}>
      <Box bg="greyLight" height="1px" flex={1} mr={2} />
      <Text fontSize={14} fontWeight={500}>
        {dateString}
      </Text>
      <Box bg="greyLight" height="1px" flex={1} ml={2} />
    </Flex>
  );
};

interface MessageListProps {
  user?: any;
  markAsRead?: any;
  cachedTotal?: number;
  messages?: any;
  loadingMore?: any;
  messagesByDate?: any;
  fetchOlderMessages?: any;
  onActionClick?: any;
}

@connect(({ user: { state: { profile } }, chat, chat: { state } }) => ({
  user: profile,
  loadingMore: state.fetchingOlder,
  messages: state.messages,
  messagesByDate: state.messagesByDate,
  markAsRead: chat.markAsRead,
  cachedTotal: state.cachedTotal,
  fetchOlderMessages: chat.fetchOlderMessages,
}))
export default class MessageList extends Component<MessageListProps, any> {
  messageRefs = {};

  get shouldLoadMore() {
    const cachedTotal = this.props.cachedTotal || 0;
    return this.props.messages.length < cachedTotal;
  }

  componentDidMount() {
    setTimeout(this.scrollToBottom);
  }

  shouldComponentUpdate(nextProps: MessageListProps) {
    const loadedOlderMessages = this.props.loadingMore && !nextProps.loadingMore;
    const loadingOlderMessages = !this.props.loadingMore && nextProps.loadingMore;
    const noNewMessages = nextProps.messages.length === this.props.messages.length;

    if (loadedOlderMessages || loadingOlderMessages) return true;
    if (noNewMessages) return false;

    return true;
  }

  componentDidUpdate(prevProps: MessageListProps) {
    if (!prevProps.loadingMore && !this.props.loadingMore) {
      this.scrollToBottom();
    }
  }

  scrollToBottom = () => {
    const id = last(Object.keys(this.messageRefs));
    const ref = id && this.messageRefs[id];

    if (ref) {
      ref.scrollIntoView();
    }
  };

  handleCellVisible = (message: any) => {
    if (!message.to || !this.props.user) return;
    if (message.to.id === this.props.user.id && !message.readAt) {
      this.props.markAsRead(message);
    }
  };

  render() {
    const { user, messagesByDate = {}, fetchOlderMessages, loadingMore } = this.props;

    if (!Object.keys(messagesByDate).length) {
      return (
        <Box textAlign="center">
          <Text color="greyDarker">No messages</Text>
        </Box>
      );
    }

    return (
      <>
        {this.shouldLoadMore && (
          <Flex justifyContent="center" mb={2}>
            <Button onClick={fetchOlderMessages} outline loading={loadingMore}>
              Load Older
            </Button>
          </Flex>
        )}

        {Object.entries(messagesByDate).map(([date, messages]: any) => {
          return (
            <React.Fragment key={date}>
              <DateHeader date={date} />
              {messages.map((message: any) => (
                <Message
                  ref={(ref) => {
                    this.messageRefs[message.id] = ref;
                  }}
                  key={message.id}
                  user={user}
                  message={message}
                  onVisible={this.handleCellVisible}
                  onActionClick={this.props.onActionClick}
                  scrollToBottom={() => {
                    if (!loadingMore) {
                      this.scrollToBottom();
                    }
                  }}
                />
              ))}
            </React.Fragment>
          );
        })}
      </>
    );
  }
}
